// extracted by mini-css-extract-plugin
export default {"declined-modal-form":"styles_declined-modal-form__SGKQG"};